<template>
  <div class="colour-picker">
    <div class="colour-picker__preview" :style="`background: ${value};`" @click.stop="$refs.picker.click()"/>
    <input ref="picker" style="display: none;" type="color" :value="value" @input="updateHex">
    <div class="colour-picker__inputs">
      <div class="colour-picker__hex">
        <label for=""><small>HEX</small></label>
        <input class="form-control" type="text" :value="value" @input="updateHex">
      </div>
      <div v-if="hexToRGB" class="colour-picker__rgb">
        <div class="channel">
          <label for=""><small>RED</small></label>
          <input class="form-control" type="number" min="0" max="255" :value="hexToRGB[0]" @input="updateRGB($event, 'r')">
        </div>
        <div class="channel">
          <label for=""><small>GREEN</small></label>
          <input class="form-control" type="number" min="0" max="255" :value="hexToRGB[1]" @input="updateRGB($event, 'g')">
        </div>
        <div class="channel">
          <label for=""><small>BLUE</small></label>
          <input class="form-control" type="number" min="0" max="255" :value="hexToRGB[2]" @input="updateRGB($event, 'b')">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['value'],

  data () {
    return {
      rgbRegex: /^#([A-Fa-f0-9]{3}){1,2}$/
    }
  },

  computed: {
    hexToRGB () {
      var hex;
      if (this.rgbRegex.test(this.value)) {
        hex = this.value.substring(1).split('')
        if (hex.length == 3) {
          hex = [hex[0], hex[0], hex[1], hex[1], hex[2], hex[2]]
        }
        hex = '0x' + hex.join('')
        return [
          (hex>>16) &255,
          (hex>>8) &255,
          hex &255
        ]
      }

      return null
    }
  },

  methods: {
    updateHex (e) {
      this.$emit('input', e.target.value)
    },

    updateRGB (event, channel) {
      let hex
      let value = event.target.value

      if (value === '' || value < 0) {
        value = 0
      }

      if (this.hexToRGB) {
        switch (channel) {
          case 'r':
            hex = '#' + ((1 << 24) + (value << 16) + (this.hexToRGB[1] << 8) + this.hexToRGB[2]).toString(16).slice(1)
            break;

          case 'g':
            hex = '#' + ((1 << 24) + (this.hexToRGB[0] << 16) + (value << 8) + this.hexToRGB[2]).toString(16).slice(1)
            break;

          case 'b':
            hex = '#' + ((1 << 24) + (this.hexToRGB[0] << 16) + (this.hexToRGB[1] << 8) + parseInt(value)).toString(16).slice(1)
            break;
        
          default:
            break;
        }

        this.$emit('input', hex)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.colour-picker {
  align-items: flex-start;
  display: flex;

  &__preview {
    box-shadow: #5e5e5e 0px 0px 3px inset;
    border-radius: 50%;
    cursor: pointer;
    height: 50px;
    width: 50px;
  }

  &__inputs {
    margin: 0 0 0 15px;
  }

  &__hex {
    align-items: center;
    display: flex;
  }

  &__rgb {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    margin: 15px 0 0;

    .channel {
      display: flex;
    }
  }

  label {
    margin: auto 10px auto 0;
    min-width: 40px;
  }
}
</style>